export enum BreadcrumbCategory {
  Auth = 'auth',
  Net = 'net',
  Playback = 'playback',
  Content = 'content',
  Media = 'media',
  Lifecycle = 'lifecycle'
}
